<template>
  <div>
    <ProductFeedsForm formAction="edit" :feedId="id" />
  </div>
</template>

<script>
import ProductFeedsForm from './components/ProductFeedsForm.vue';

export default {
  components: {
    ProductFeedsForm,
  },
  props: ['id'],
};
</script>
